// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2kF4e","selected":"Chip_selected__ZCgYn"};